import * as Yup from 'yup';

import i18n from '@/i18n';

export const createFolderSchema = Yup.object().shape({
  name: Yup.string()
    .required(i18n.t('nameRequired', { ns: 'common' }))
    .min(2, i18n.t('nameMin', { ns: 'common' }))
    .max(35, i18n.t('nameMax', { ns: 'common' }))
});
